<script setup>
import IconAlertNotify from "@/components/Icons/IconAlertNotify.vue";
import { t } from "@/controllerLK/AvalLocalization";
import { defineProps, defineEmits } from "vue";

defineProps({
  text: {
    type: String,
    required: true,
    default: ""
  }
});

const emit = defineEmits(["close-notify"]);
</script>

<template>
  <div class="notify-alert">
    <IconAlertNotify class="notify-alert__icon notify-alert__icon--alert" />
    <span class="notify-alert__text ">{{ text }}</span>
    <IconCross
      v-tooltip:bottom-right="t('news_page_rubrics_edit_popup.tooltip.never_show')"
      class="notify-alert__icon notify-alert__icon--cross"
      @click="emit('close-notify')"
    />
  </div>
</template>

<style scoped lang="scss">
.notify-alert {
  display: flex;
  gap: 10px;
  border-radius: 8px;
  padding: 10px;
  background-color: var(--blue-blue20);

  &__text {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--text-text-main);
  }

  &__icon {
    &--cross {
      margin-left: auto;
      cursor: pointer;
      color: var(--icon-icon-secondary);
      min-width: 14px;
      min-height: 14px;

      &:hover {
        color: var(--icon-icon-on);
      }
    }

    &--alert {
      color: var(--icon-icon-on);
      min-width: 20px;
      min-height: 20px;
    }
  }
}
</style>